import React from 'react'
import { css } from '@emotion/react'
import { VscChromeClose } from 'react-icons/vsc'
import { fadeInRight } from '../utility/animation'

function Modal({ children, style, visible, onClose }) {
    return (
        <div
            css={css`
                position: fixed;
                top: 0;
                right: 0;
                background-color: rgba(0, 0, 0, 0.7);
                backdrop-filter: blur(10px);
                width: 100vw;
                height: 100vh;
                z-index: 99;
                display: ${visible ? 'flex' : 'none'};
                justify-content: center;
                align-items: center;
                animation: ${fadeInRight} 1s ease;
                ${style}
            `}
            className="modal"
        >
            <button
                css={css`
                    position: absolute;
                    top: 40px;
                    right: 40px;
                    font-size: 2.5rem;
                    svg {
                        color: #ffffff !important;
                    }
                `}
                onClick={() => {
                    onClose?.()
                }}
            >
                <VscChromeClose />
            </button>
            {children}
        </div>
    )
}

export default Modal
